
import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import NavBar from '../../../component/b2c/navBar/navBar';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import { FaCcVisa, FaCcMastercard } from 'react-icons/fa';
import '../../../css/custom-scrollbar.css';
// import { IoClose } from "react-icons/io5";
import { Base_Url, payment, walletRecharge, grandTotalAmount, updatewalletAmount, amountUpdate } from '../../../config/config';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Loader from '../../../component/spinner/spinner';
import { X, CreditCard, User, ArrowUp, CheckCircle } from 'lucide-react';

const B2bWalletRecharge = ()=> {
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');
  const role = localStorage.getItem('role');
  const [loader, setLoader] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [paymentUrl, setPaymentUrl] = useState('');
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const location = useLocation();
  const [totalAmount, setTotalAmount] = useState(0);
  const [currentBalanace, setCurrentBalanace] = useState(0);

  // New state for update wallet popup
  const [isUpdatePopupOpen, setIsUpdatePopupOpen] = useState(false);
  const [updateData, setUpdateData] = useState({
    txn_id: '',
    user_id: '',
    amount: '',
    type: 'add'
  });
  const [updateLoader, setUpdateLoader] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.status === "paid") {
        setTimeout(() => {
          window.location.href = "";
          setPaymentUrl('');
        }, 3000);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (role === "admin") {
      getTotalAmount();
    }
    getPayment();
  }, []);

  const getTotalAmount = async () => {
    const uri = Base_Url + "admin/" + grandTotalAmount;
    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(uri, {
        method: "GET",
        headers: {
          "token": token,
          "cus_id": cusid,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.status === "SUCCESS") {
        setTotalAmount(data.grand_total);
      } else {
        console.error("Error:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const getPayment = async () => {
    const url = Base_Url + payment
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        setCurrentBalanace(data.totalamount);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleRecharge = async (e) => {
    e.preventDefault();

    if (!amount || isNaN(amount)) {
      toast.error('Please enter a valid amount');
      return;
    }

    // Calculate service charge and GST
    const serviceCharge = (amount * 0.025).toFixed(2); // 2.5% service charge
    const gst = (serviceCharge * 0.18).toFixed(2); // 18% GST
    const totalAmount = (parseFloat(amount) - parseFloat(serviceCharge) - parseFloat(gst)).toFixed(2);

    // Calculate credit card discount if applicable
    const maxDiscount = 5000;
    const discountRate = 0.05; // 5% discount
    const creditCardDiscountText = parseFloat(amount) <= maxDiscount
      ? `Recharge ₹5,000 or more and get 5% cashback — up to ₹250! `
      : '';

    // Show SweetAlert confirmation
    const result = await Swal.fire({
      title: '<span style="color: #4a6bdf; font-weight: 600;">Wallet Recharge</span>',
      html: `
        <div style="text-align: left; padding: 10px; border-radius: 8px; background-color: #f8f9fa;">
          <div style="display: flex; justify-content: center; margin-bottom: 15px;">
            <div style="background-color: #4a6bdf; color: white; border-radius: 50%; width: 60px; height: 60px; display: flex; align-items: center; justify-content: center; font-size: 24px;">
              <i class="fas fa-wallet"></i>
            </div>
          </div>
          
          <div style="margin-bottom: 15px; padding: 15px; border-radius: 8px; background-color: white; box-shadow: 0 2px 5px rgba(0,0,0,0.08);">
            <p style="font-size: 16px; margin-bottom: 10px;">Recharge Amount: <span style="float: right; font-weight: 600; color: #4a6bdf;">₹${amount}</span></p>
            <p style="font-size: 14px; color: #666; margin-bottom: 5px;">Service charge (2.5%): <span style="float: right;">₹${serviceCharge}</span></p>
            <p style="font-size: 14px; color: #666; margin-bottom: 5px;">GST (18%): <span style="float: right;">₹${gst}</span></p>
            <hr style="border-top: 1px dashed #ddd; margin: 10px 0;">
            <p style="font-size: 16px; margin: 0; font-weight: 600;">Total to Wallet: <span style="float: right; color: #2e7d32;">₹${totalAmount}</span></p>
          </div>
          
          <div style="background-color: #e3f2fd; padding: 12px; border-radius: 8px; border-left: 4px solid #2196f3; margin-bottom: 10px;">
            <p style="margin: 0; color: #0d47a1; display: flex; align-items: center;">
              <i class="fas fa-credit-card" style="margin-right: 8px;"></i>
              <span style="font-weight: 500;">${creditCardDiscountText}</span>
            </p>
          </div>
          
          <div style="background-color: #fff3e0; padding: 10px; border-radius: 8px; border-left: 4px solid #ff9800;">
            <p style="margin: 0; color: #e65100; font-size: 13px; display: flex; align-items: center;">
              <i class="fas fa-exclamation-circle" style="margin-right: 8px;"></i>
              <span>Additional charges may apply when using a credit card.</span>
            </p>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: '<i class="fas fa-check-circle"></i> Proceed',
      cancelButtonText: '<i class="fas fa-times-circle"></i> Cancel',
      confirmButtonColor: '#4a6bdf',
      cancelButtonColor: '#f44336',
      buttonsStyling: true,
      customClass: {
        container: 'my-swal-container',
        popup: 'my-swal-popup',
        header: 'my-swal-header',
        title: 'my-swal-title',
        closeButton: 'my-swal-close-button',
        content: 'my-swal-content',
        actions: 'my-swal-actions',
        confirmButton: 'my-swal-confirm-button',
        cancelButton: 'my-swal-cancel-button',
        footer: 'my-swal-footer'
      },
      showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
      }
    });

    if (result.isConfirmed) {
      try {
        setLoader(true);
        const uri = Base_Url + walletRecharge;
        const response = await axios.post(
          uri,
          { amount },
          {
            headers: {
              token: token,
              cus_id: cus_id,
              "Content-Type": "application/json"
            },
          }
        );

        if (response.data.status === "SUCCESS") {
          const url = response.data?.data?.link;
          setPaymentUrl(url);
          setAmount('');
          setCoupon('');
          setLoader(false);
        } else {
          toast.error(response.data.message || 'Recharge failed');
          setLoader(false);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'An error occurred');
        setLoader(false);
      }
    }
  };

  // Handle opening update wallet popup
  const handleOpenUpdatePopup = () => {
    setIsUpdatePopupOpen(true);
    // Initialize with default cus_id from localStorage if available
    setUpdateData(prevState => ({
      ...prevState,
    }));
  };

  // Handle closing update wallet popup
  const handleCloseUpdatePopup = () => {
    setIsUpdatePopupOpen(false);
    setUpdateData({
      txn_id: '',
      user_id: '',
      amount: '',
      type: 'add'
    });
  };

  // Handle change in update form fields
  const handleUpdateInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateData({
      ...updateData,
      [name]: value
    });
  };

  // Handle submit for wallet update
  const handleUpdateWallet = async (e) => {
    e.preventDefault();

    // Validate input fields
    if (!updateData.txn_id.trim()) {
      toast.error('Transaction ID is required');
      return;
    }

    if (!updateData.user_id.trim()) {
      toast.error('Customer ID is required');
      return;
    }

    try {
      setUpdateLoader(true);
      const uri = Base_Url + amountUpdate;

      const response = await axios.post(
        uri,
        updateData,
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "application/json"
          },
        }
      );

      if (response.data && response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        handleCloseUpdatePopup();
        getPayment();
      } else {
        toast.error(
          response.data?.message ||
          response.data?.messsge ||
          response.data?.messages?.error ||
          'Failed to update wallet'
        );
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        error.response?.data?.messsge ||
        error.response?.data?.messages?.error ||
        'An error occurred'
      )
    } finally {
      setUpdateLoader(false);
    }
  };

  const viewHistory = () => {
    navigate('/b2b/payments/topuphistory');
  };

  const viewShipmentCharges = () => {
    navigate('/b2b/payments/shippingCharges');
  };


  const handleAmountChange = (e) => {
    const val = e.target.value;
    // const num = Number(val);

    if (val > 50000) {
      toast.error("Amount cannot exceed ₹50,000");
      setError("Amount cannot exceed ₹50,000");
    } else {
      setError('');
      setAmount(val);
    }
  };


  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }
          >
            <Sidebar />
          </div>
        )}

        <div className="container mx-auto p-6 w-full bg-white rounded-custom shadow-custom-light dark:shadow-custom-dark flex flex-col md:flex-row dark:bg-darkmodeColor font-sans md:ml-4 md:mt-4 md:mb-6 md:mr-4 custom-scrollbar overflow-y-auto">
          {/* Main Content Section */}
          <div className="container mb-0 md:mb-0 mx-auto p-8 bg-white dark:bg-darkmodeColor shadow-custom-light dark:shadow-custom-dark rounded-custom md:max-w-[80%] w-full overflow-y-auto custom-scrollbar min-h-full relative">

            {/* Decorative Background Elements */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
              <div className="absolute top-10 right-10 w-32 h-32 bg-gradient-to-br from-purple-400/10 to-blue-400/10 rounded-full blur-3xl"></div>
              <div className="absolute bottom-20 left-10 w-24 h-24 bg-gradient-to-tr from-indigo-400/10 to-purple-400/10 rounded-full blur-2xl"></div>
            </div>

            {/* Header Section */}
            <div className="mb-8 text-center relative z-10">
              <div className="relative inline-block">
                <button className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 bg-customPurple via-purple-700 to-indigo-600 hover:from-purple-700 hover:via-purple-800 hover:to-indigo-700 text-white font-sans px-6 sm:px-8 py-3 sm:py-4 rounded-xl h-auto w-full sm:w-full flex items-center justify-center transition-all duration-300 transform hover:scale-[1.02] hover:shadow-2xl shadow-lg border border-purple-500/20">
                  <div className="flex items-center space-x-3">
                    <div className="flex items-center space-x-1">
                      <FaCcVisa className="text-white drop-shadow-lg" size={28} />
                      <FaCcMastercard className="text-white drop-shadow-lg" size={28} />
                    </div>
                    <span className="text-transparent text-white font-extrabold tracking-wide">
                      Wallet Recharge
                    </span>
                  </div>
                </button>
              </div>
            </div>

            {/* Payment Modal */}
            {paymentUrl && (
              <div className="fixed inset-0 z-50 bg-white">
                {/* <button className="absolute top-4 right-4 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white p-3 rounded-full flex items-center justify-center z-60 shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-110">
                  <IoClose size={24} />
                </button> */}
                <iframe
                  src={paymentUrl}
                  width="100%"
                  height="100%"
                  className="border-none"
                />
              </div>
            )}

            {/* Current Balance Card */}
            <div className="mb-8 relative z-10">
              <div className="p-6 w-full rounded-2xl text-center shadow-custom-light dark:shadow-custom-dark bg-gradient-to-br from-purple-50 to-indigo-50 dark:from-purple-900/20 dark:to-indigo-900/20 border border-purple-200/50 dark:border-purple-700/30 backdrop-blur-sm">
                <div className="flex items-center justify-center mb-2">
                  <div className="w-8 h-8 bg-customPurple rounded-full flex items-center justify-center mr-3">
                    <span className="text-white font-bold text-sm">₹</span>
                  </div>
                  <h3 className="text-sm font-semibold text-gray-600 dark:text-purple-200 uppercase tracking-wide">Current Balance</h3>
                </div>
                <p className="text-3xl font-black bg-customPurple bg-clip-text text-transparent">
                  ₹{currentBalanace}
                </p>
                <div className="mt-3 h-1 bg-customPurple to-indigo-500 rounded-full mx-auto w-20"></div>
              </div>
            </div>

            {/* Admin Update Button */}
            {role === "admin" && (
              <div className="mb-8 relative z-10">
                <Button
                  onClick={handleOpenUpdatePopup}
                  variant="contained"
                  sx={{
                    background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                    color: 'white',
                    textTransform: 'capitalize',
                    borderRadius: '12px',
                    padding: '12px 24px',
                    boxShadow: '0 8px 32px rgba(76, 175, 80, 0.3)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #45a049 0%, #388e3c 100%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 12px 40px rgba(76, 175, 80, 0.4)',
                    },
                  }}
                  className="w-full font-sans capitalize py-3 text-sm font-semibold transition-all duration-300"
                >
                  <span className="flex items-center justify-center space-x-2">
                    <span>🔧</span>
                    <span>Update Wallet Balance</span>
                  </span>
                </Button>
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6 mb-8 relative z-10">
              <Button
                onClick={viewShipmentCharges}
                variant="contained"
                sx={{
                  background: 'linear-gradient(135deg, hsl(265, 58%, 58%) 0%, hsl(270, 67%, 39%) 100%)',
                  color: 'white',
                  textTransform: 'capitalize',
                  borderRadius: '12px',
                  padding: '14px 20px',
                  boxShadow: '0 8px 32px hsla(265, 58%, 58%, 0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, hsl(270, 67%, 39%) 0%, hsl(275, 70%, 35%) 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 40px hsla(265, 58%, 58%, 0.4)',
                  },
                }}
                className="flex-1 font-sans text-sm font-semibold transition-all duration-300"
              >
                <span className="flex items-center justify-center space-x-2">
                  <span>🚛</span>
                  <span>Shipment Charges</span>
                </span>
              </Button>

              <Button
                onClick={viewHistory}
                variant="contained"
                sx={{
                  background: 'linear-gradient(135deg, hsl(265, 58%, 58%) 0%, hsl(270, 67%, 39%) 100%)',
                  color: 'white',
                  textTransform: 'capitalize',
                  borderRadius: '12px',
                  padding: '14px 20px',
                  boxShadow: '0 8px 32px hsla(265, 58%, 58%, 0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, hsl(270, 67%, 39%) 0%, hsl(275, 70%, 35%) 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 40px hsla(265, 58%, 58%, 0.4)',
                  },
                }}
                className="flex-1 font-sans text-sm font-semibold transition-all duration-300"
              >
                <span className="flex items-center justify-center space-x-2">
                  <span>📊</span>
                  <span>View Topup History</span>
                </span>
              </Button>
            </div>

            {/* Recharge Form */}
            <form onSubmit={handleRecharge} className="space-y-6 dark:text-white relative z-10">
              <div className="space-y-4">
                <div className="relative group">
                  <label htmlFor="amount" className="block text-sm font-semibold text-gray-700 dark:text-white mb-2 flex items-center space-x-2">
                    <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
                    <span>Custom Amount</span>
                  </label>
                  <div className="relative">
                    <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-purple-600 dark:text-purple-400 font-bold text-lg">₹</span>
                    <input
                      type="number"
                      id="amount"
                      value={amount}
                      onChange={handleAmountChange}
                      placeholder="Enter amount"
                      className={`w-full pl-10 pr-4 py-4 border-2 ${error
                        ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20'
                        : 'border-gray-200 dark:border-purple-700/30 focus:border-purple-500 focus:ring-purple-500/20'
                        } shadow-custom-light dark:shadow-custom-dark rounded-xl dark:bg-darkmodeColor dark:text-white transition-all duration-300 font-medium text-lg group-hover:border-purple-400`}
                      required
                    />
                  </div>
                </div>

                <div className="relative group">
                  <label htmlFor="coupon" className="block text-sm font-semibold text-gray-700 dark:text-white mb-2 flex items-center space-x-2">
                    <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                    <span>Apply Coupon</span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">(optional)</span>
                  </label>
                  <div className="relative">
                    <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-green-600 dark:text-green-400 font-bold">🎫</span>
                    <input
                      type="text"
                      id="coupon"
                      value={coupon}
                      onChange={(e) => setCoupon(e.target.value)}
                      placeholder="Enter coupon code"
                      className="w-full pl-12 pr-4 py-4 border-2 border-gray-200 dark:border-purple-700/30 shadow-custom-light dark:shadow-custom-dark rounded-xl dark:bg-darkmodeColor dark:text-white focus:border-green-500 focus:ring-4 focus:ring-green-500/20 transition-all duration-300 font-medium group-hover:border-green-400"
                    />
                  </div>
                </div>
              </div>

              <Button
                type="submit"
                variant="contained"
                sx={{
                  background: 'linear-gradient(135deg, hsl(265, 58%, 58%) 0%, hsl(270, 67%, 39%) 100%)',
                  color: 'white',
                  textTransform: 'capitalize',
                  borderRadius: '16px',
                  padding: '16px 32px',
                  fontSize: '16px',
                  fontWeight: '700',
                  boxShadow: '0 12px 40px hsla(265, 58%, 58%, 0.4)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, hsl(270, 67%, 39%) 0%, hsl(275, 70%, 35%) 100%)',
                    transform: 'translateY(-3px)',
                    boxShadow: '0 16px 50px hsla(265, 58%, 58%, 0.5)',
                  },
                }}
                className="w-full font-sans transition-all duration-300"
              >
                {loader ? (
                  <div className="flex items-center justify-center space-x-3">
                    <Loader />
                    <span>Processing...</span>
                  </div>
                ) : (
                  <span className="flex items-center justify-center space-x-3">
                    <span>⚡</span>
                    <span>Recharge Now</span>
                    <span>⚡</span>
                  </span>
                )}
              </Button>
            </form>

            {/* Update Wallet Popup */}
            {isUpdatePopupOpen && (
              <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-50 p-4">
                <div className="bg-white dark:bg-slate-900 rounded-2xl p-8 max-w-md w-full shadow-2xl transform transition-all duration-300 border border-gray-200 dark:border-slate-800 relative overflow-hidden">

                  {/* Decorative Background */}
                  <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-purple-400/20 to-transparent rounded-full -translate-y-16 translate-x-16"></div>

                  <div className="flex justify-between items-center mb-8 relative z-10">
                    <h2 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent">
                      Update Wallet Balance
                    </h2>
                    <button
                      onClick={handleCloseUpdatePopup}
                      className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white transition-colors duration-200 rounded-full p-2 hover:bg-gray-100 dark:hover:bg-slate-800"
                    >
                      <X size={24} />
                    </button>
                  </div>

                  <div className="space-y-6 relative z-10">
                    <div className="relative">
                      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-3 flex items-center gap-2">
                        <CreditCard size={18} className="text-purple-500" />
                        Transaction ID
                      </label>
                      <input
                        type="text"
                        name="txn_id"
                        value={updateData.txn_id}
                        onChange={handleUpdateInputChange}
                        placeholder="Enter transaction ID"
                        className="w-full p-4 border-2 border-gray-200 dark:border-slate-700 rounded-xl shadow-sm focus:ring-4 focus:ring-purple-500/20 focus:border-purple-500 dark:bg-slate-800 dark:text-white transition-all duration-200 font-medium"
                        required
                      />
                    </div>

                    <div className="relative">
                      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-3 flex items-center gap-2">
                        <CreditCard size={18} className="text-purple-500" />
                        Amount
                      </label>
                      <input
                        type="number"
                        name="amount"
                        min="0"
                        step="1"
                        value={updateData.amount}
                        onChange={handleUpdateInputChange}
                        placeholder="Enter Amount"
                        className="w-full p-4 border-2 border-gray-200 dark:border-slate-700 rounded-xl shadow-sm focus:ring-4 focus:ring-purple-500/20 focus:border-purple-500 dark:bg-slate-800 dark:text-white transition-all duration-200 font-medium"
                        required
                      />
                    </div>

                    <div className="relative">
                      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-3 flex items-center gap-2">
                        <User size={18} className="text-purple-500" />
                        Customer ID
                      </label>
                      <input
                        type="number"
                        name="user_id"
                        value={updateData.user_id}
                        onChange={handleUpdateInputChange}
                        min="0"
                        step="1"
                        placeholder="Enter customer ID"
                        className="w-full p-4 border-2 border-gray-200 dark:border-slate-700 rounded-xl shadow-sm focus:ring-4 focus:ring-purple-500/20 focus:border-purple-500 dark:bg-slate-800 dark:text-white transition-all duration-200 font-medium"
                        required
                      />
                    </div>

                    <div className="relative">
                      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-3 flex items-center gap-2">
                        <ArrowUp size={18} className="text-purple-500" />
                        Type
                      </label>
                      <div className="relative">
                        <select
                          name="type"
                          value={updateData.type}
                          onChange={handleUpdateInputChange}
                          className="w-full p-4 border-2 border-gray-200 dark:border-slate-700 rounded-xl shadow-sm bg-gray-50 dark:bg-slate-800 dark:text-white appearance-none  opacity-75 font-medium"
                        >
                          <option value="add">Add</option>
                          <option value="deduct">Deduct</option>
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                          <svg className="h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                          </svg>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-end space-x-4 mt-10 pt-6 border-t border-gray-200 dark:border-slate-700">
                      <button
                        type="button"
                        onClick={handleCloseUpdatePopup}
                        className="px-6 py-3 text-sm font-semibold text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 focus:outline-none focus:ring-4 focus:ring-gray-500/20 transition-all duration-200 dark:bg-slate-800 dark:text-gray-300 dark:hover:bg-slate-700"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={handleUpdateWallet}
                        className="px-6 py-3 text-sm font-semibold text-white bg-gradient-to-r from-purple-600 to-indigo-600 rounded-xl hover:from-purple-700 hover:to-indigo-700 focus:outline-none focus:ring-4 focus:ring-purple-500/20 transition-all duration-200 flex items-center justify-center min-w-[100px] shadow-lg hover:shadow-xl transform hover:scale-105"
                      >
                        {updateLoader ? (
                          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                          <span className="flex items-center gap-2">
                            <CheckCircle size={18} />
                            Submit
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Terms & Conditions Section */}
          <div className="w-full mt-4 md:mt-0 md:w-12/12 p-8 min-h-full rounded-custom flex flex-col dark:bg-darkmodeColor dark:text-white shadow-custom-light dark:shadow-custom-dark font-sans md:ml-2 custom-scrollbar overflow-y-auto relative">

            {/* Decorative Elements */}
            <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-red-400/10 to-transparent rounded-full -translate-y-12 translate-x-12"></div>

            <div className="relative z-10">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-1 h-8 bg-gradient-to-b from-red-500 to-red-600 rounded-full"></div>
                <h1 className="text-red-500 font-bold font-sans text-sm uppercase tracking-wide">
                  Terms & Conditions for Wallet Top-Up
                </h1>
              </div>

              <div className="bg-gradient-to-r from-red-50 to-orange-50 dark:from-red-900/10 dark:to-orange-900/10 border-l-4 border-red-500 p-4 rounded-r-xl mb-6">
                <p className="font-medium font-sans text-sm leading-relaxed">
                  These Terms & Conditions ("T&Cs") govern the top-up of funds
                  ("Top-Up") into your wallet account ("Wallet") on PICKUPXPRESS. By
                  topping up your Wallet, you agree to these T&Cs.
                </p>
              </div>

              <div className="space-y-6">
                {[
                  {
                    title: "1. Eligibility",
                    content: "* You must be a registered user of the PICKUPXPRESS to top up your Wallet.\n* You must comply with all applicable laws and regulations when topping up your Wallet."
                  },
                  {
                    title: "2. Top-Up Process",
                    content: "* To add funds to your Wallet, you may use the available payment methods supported by the PICKUPXPRESS, including credit/debit cards, bank transfers, Wallet/UPI.\n* All Top-Up transactions are final and cannot be reversed or refunded unless required by law or expressly stated in these T&Cs.\n* The minimum and maximum amounts for a Top-Up are subject to limits as determined by the Platform from time to time."
                  },
                  {
                    title: "3. Processing of Funds",
                    content: "* Funds topped up into your Wallet will show in your balance within 0-36 hours depending on the payment method used.\n* The Platform is not responsible for delays caused by the payment processing service or other third parties.\n* The Wallet balance is non-transferable and can only be used for services on the PICKUPXPRESS platform."
                  },
                  {
                    title: "4. Fees and Charges",
                    content: "* The Platform may charge fees for Top-Up transactions, which will be disclosed at the time of the transaction.\n* Any applicable fees or taxes, including foreign exchange fees for cross-border transactions, will be borne by the user."
                  },
                  {
                    title: "5. Usage of Wallet Funds",
                    content: "* Funds in your Wallet can only be used for transactions within the PICKUPXPRESS.\n* Wallet funds cannot be withdrawn, transferred, or redeemed for cash, except where required by law or as specified by the PICKUPXPRESS."
                  },
                  {
                    title: "6. Account Security",
                    content: "* You are responsible for maintaining the security of your account and ensuring that your login credentials are not shared with others.\n* The Platform is not liable for any unauthorized access to your account or Wallet due to your negligence."
                  },
                  {
                    title: "7. Expiration and Forfeiture of Funds",
                    content: "* Wallet balances may expire or be subject to forfeiture after a specified period of inactivity as determined by the PICKUPXPRESS policies.\n* The Platform will provide reasonable notice before any such expiration or forfeiture of funds."
                  },
                  {
                    title: "8. Fraud Prevention",
                    content: "* The PICKUPXPRESS reserves the right to suspend or terminate your account and Wallet, and to investigate any Top-Up transaction suspected of being fraudulent or in violation of these T&Cs.\n* Any attempt to defraud the PICKUPXPRESS or misuse the Wallet will result in legal action and forfeiture of funds."
                  },
                  {
                    title: "9. Changes to Terms & Conditions",
                    content: "* The Platform reserves the right to modify these T&Cs at any time. Any changes will be communicated to users through the PICKUPXPRESS or via email.\n* Continued use of the Wallet after changes to these T&Cs will constitute acceptance of the modified terms."
                  },
                  {
                    title: "10. Governing Law",
                    content: "* Any disputes arising out of or related to these T&Cs will be subject to the exclusive jurisdiction of the courts of Gautam Budh Nagar/India."
                  },
                  {
                    title: "11. Contact Information",
                    content: "If you have any questions or concerns regarding these T&Cs, please contact our support team at [support@pickupxpress.com]."
                  }
                ].map((section, index) => (
                  <div key={index} className="group">
                    <div className="flex items-start space-x-3 mb-3">
                      <div className="w-2 h-2 bg-purple-500 rounded-full mt-2 group-hover:bg-purple-400 transition-colors duration-200"></div>
                      <h3 className="font-bold font-sans text-sm text-gray-800 dark:text-white group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors duration-200">
                        {section.title}
                      </h3>
                    </div>
                    <div className="ml-5 pl-4 border-l border-gray-200 dark:border-gray-700">
                      <p className="font-medium font-sans text-xs leading-relaxed text-gray-700 dark:text-gray-300 whitespace-pre-line">
                        {section.content}
                      </p>
                    </div>
                  </div>
                ))}

                {/* Payment Methods Section */}
                <div className="mt-8 p-6 bg-gradient-to-br from-purple-50 to-indigo-50 dark:from-purple-900/20 dark:to-indigo-900/20 rounded-2xl border border-purple-200/50 dark:border-purple-700/30">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    <h3 className="font-bold font-sans text-sm text-gray-800 dark:text-white">
                      Payment Methods Supported for PICKUPXPRESS Wallet Top-Up:
                    </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-white/50 dark:bg-black/20 p-4 rounded-xl">
                      <h4 className="font-semibold text-xs text-purple-600 dark:text-purple-400 mb-2">Credit/Debit Cards:</h4>
                      <ul className="space-y-1 text-xs font-medium text-gray-700 dark:text-gray-300">
                        <li>• Visa</li>
                        <li>• MasterCard</li>
                        <li>• American Express</li>
                        <li>• Discover</li>
                      </ul>
                    </div>

                    <div className="bg-white/50 dark:bg-black/20 p-4 rounded-xl">
                      <h4 className="font-semibold text-xs text-purple-600 dark:text-purple-400 mb-2">Digital Wallets:</h4>
                      <ul className="space-y-1 text-xs font-medium text-gray-700 dark:text-gray-300">
                        <li>• Paytm</li>
                        <li>• Google Pay</li>
                        <li>• PhonePe</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2bWalletRecharge;
